var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginGraphic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 462,
    height: 418,
    viewBox: "0 0 462 418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#476687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#273B50",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-2",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#294767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#273B50",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    d: "M29.1471816,1.31639045 C29.8783848,0.950788838 30.4999356,0.895892436 31.011834,1.15184165 C31.5237325,1.40779086 31.7796817,1.90143728 31.7796817,2.6326405 L31.7796817,18.4276411 C31.7796817,19.1588444 31.5237325,19.90844 31.011834,20.6761472 C30.4999356,21.4439949 29.8783848,22.0106493 29.1471816,22.3763913 L28.2696815,22.8151413 L28.2696815,23.6926413 C28.2696815,24.4238446 28.0137323,25.1732998 27.5018339,25.9411474 C26.9899355,26.7089951 26.3683846,27.2756495 25.6371814,27.6412511 L2.82218051,39.0487516 C2.09097728,39.4143532 1.46942646,39.4692496 0.957528038,39.2133004 C0.445629618,38.9573511 0.189680408,38.4638451 0.189680408,37.7325015 L0.189680408,21.9376413 C0.189680408,21.2062976 0.445629618,20.4568424 0.957528038,19.6889948 C1.46942646,18.9211472 2.09097728,18.3544927 2.82218051,17.9888911 L3.69968055,17.5501411 L3.69968055,16.6726411 C3.69968055,15.9412974 3.95562976,15.1918422 4.46752818,14.4239946 C4.9794266,13.6561469 5.60097742,13.0894925 6.33218065,12.7238909 L29.1471816,1.31639045 Z M26.5146815,24.570001 L26.5146815,23.6926413 L6.33218065,33.7837513 C5.60097742,34.1494934 4.9794266,34.2042494 4.46752818,33.9483001 C3.95562976,33.6923509 3.69968055,33.1988449 3.69968055,32.4675013 L3.69968055,19.3051412 L2.82218051,19.7438912 C2.5662313,19.8717956 2.35605249,20.0592296 2.19150369,20.3059124 C2.02695488,20.5527356 1.94468048,20.804192 1.94468048,21.0601412 L1.94468048,36.8550015 C1.94468048,37.1109507 2.02695488,37.2801327 2.19150369,37.3624071 C2.35605249,37.4446815 2.5662313,37.4217963 2.82218051,37.2937515 L25.6371814,25.886251 C25.8931306,25.7583466 26.1033094,25.5709126 26.2678582,25.3242298 C26.4324071,25.0774066 26.5146815,24.8259502 26.5146815,24.570001 Z M30.0246816,19.3051412 L30.0246816,3.51014054 C30.0246816,3.25419133 29.9424072,3.08500932 29.7778584,3.00287532 C29.6133096,2.92060092 29.4031308,2.94334572 29.1471816,3.07139052 L6.33218065,14.478891 C6.07623144,14.6067954 5.86605263,14.7942294 5.70150383,15.0410526 C5.53695502,15.2877354 5.45468062,15.5391918 5.45468062,15.795141 L5.45468062,31.5900013 C5.45468062,31.8459505 5.53695502,32.0151325 5.70150383,32.0974069 C5.86605263,32.1796813 6.07623144,32.1567961 6.33218065,32.0287513 L29.1471816,20.6213912 C29.4031308,20.4933464 29.6133096,20.3060528 29.7778584,20.0592296 C29.9424072,19.8124064 30.0246816,19.5610904 30.0246816,19.3051412 Z M9.84218079,20.1826412 C9.00118476,20.6029988 8.27910753,20.6625284 7.67580871,20.3608088 C7.07265028,20.0592296 6.77093067,19.487942 6.77093067,18.6469459 C6.77093067,17.8060903 7.07265028,16.9330831 7.67580871,16.028205 C8.27910753,15.123327 9.00118476,14.4604986 9.84218079,14.040141 C10.6831768,13.6196429 11.4052541,13.5602537 12.0085529,13.861833 C12.6118517,14.1635526 12.9134309,14.7348402 12.9134309,15.5756958 C12.9134309,16.4166919 12.6118517,17.2895587 12.0085529,18.1944367 C11.4052541,19.0994552 10.6831768,19.7621432 9.84218079,20.1826412 Z M9.84218079,15.795141 C9.47657918,15.9779418 9.16573356,16.261269 8.90978435,16.6451227 C8.65397554,17.0291167 8.52593074,17.4038443 8.52593074,17.7694459 C8.52593074,18.1350475 8.65397554,18.3818707 8.90978435,18.5099155 C9.16573356,18.6378199 9.47657918,18.6104419 9.84218079,18.4276411 C10.2077824,18.2448403 10.518628,17.9613727 10.7745772,17.5775191 C11.0305264,17.1936655 11.1584308,16.8187975 11.1584308,16.4531959 C11.1584308,16.0875942 11.0305264,15.840771 10.7745772,15.7128666 C10.518628,15.5848218 10.2077824,15.6123402 9.84218079,15.795141 Z M23.0594373,10.4478664 L27.8856875,12.8609213 C28.1416367,12.9889661 28.2696815,13.2357893 28.2696815,13.6013909 L28.2696815,18.6469459 C28.2696815,18.8297467 28.2056591,19.0171808 28.0777547,19.2091076 C27.9497099,19.4010344 27.7942871,19.542698 27.6114863,19.6340984 L7.86787591,29.506044 C7.68493471,29.5974444 7.5296523,29.6110632 7.40160749,29.5471812 C7.27370309,29.4831588 7.20968069,29.3597472 7.20968069,29.1769464 L7.20968069,27.6412511 C7.20968069,27.2756495 7.33772549,26.9009219 7.5935343,26.5170683 L12.4197845,19.2776228 C12.6757337,18.8937692 12.9865793,18.6104419 13.3521809,18.4276411 C13.7177825,18.2448403 14.0286282,18.2173219 14.2845774,18.3453667 L15.984681,19.1953484 L21.1947848,11.3801225 C21.4507341,10.9962688 21.7615797,10.7129416 22.1271813,10.5301408 C22.4927829,10.34734 22.8036285,10.3198216 23.0594373,10.4478664 Z M26.5146815,18.4276411 L8.96468076,27.2025011 L8.96468076,26.9282999 L13.3521809,20.3470496 L15.984681,21.6632997 L22.1271813,12.4496897 L26.5146815,14.6434398 L26.5146815,18.4276411 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    d: "M12.7210829,9.44751638 C12.7210829,9.26471557 12.7849649,9.07742196 12.9130097,8.88535475 C13.0409141,8.69342795 13.1963369,8.55176434 13.3791377,8.46036394 L18.5344855,5.88276023 C18.7172863,5.79135983 18.8727091,5.77760063 19.0006136,5.84162303 C19.128518,5.90564543 19.1925404,6.02891664 19.1925404,6.21171745 L19.1925404,6.54081506 C19.1925404,6.72361587 19.128518,6.91104987 19.0006136,7.10297668 C18.8727091,7.29490349 18.7172863,7.4365671 18.5344855,7.5279675 L16.9440343,8.32319313 L16.9440343,22.5826389 L18.5344855,21.7874133 C18.7172863,21.6960129 18.8727091,21.6822537 19.0006136,21.7462761 C19.128518,21.8101581 19.1925404,21.9335697 19.1925404,22.1163705 L19.1925404,22.4454681 C19.1925404,22.6282689 19.128518,22.8157029 19.0006136,23.0076297 C18.8727091,23.1995565 18.7172863,23.3412201 18.5344855,23.4326205 L13.3791377,26.0103646 C13.1963369,26.101765 13.0409141,26.1153838 12.9130097,26.0515018 C12.7849649,25.9874794 12.7210829,25.8640678 12.7210829,25.681267 L12.7210829,25.3521694 C12.7210829,25.1693686 12.7849649,24.982075 12.9130097,24.7900078 C13.0409141,24.598081 13.1963369,24.4564174 13.3791377,24.365017 L14.969589,23.5697913 L14.969589,17.2627423 L5.20743621,22.1438889 L5.20743621,28.4509379 L6.79788747,27.6555719 C6.98068828,27.5641715 7.13611108,27.5505527 7.26401549,27.6145751 C7.39206029,27.6784571 7.4560827,27.8018687 7.4560827,27.9846695 L7.4560827,28.3137671 C7.4560827,28.4965679 7.39206029,28.6840019 7.26401549,28.8759287 C7.13611108,29.0678556 6.98068828,29.2095192 6.79788747,29.3009196 L1.64253967,31.8786637 C1.45973886,31.9700641 1.30445645,31.9836829 1.17641165,31.9196605 C1.04850724,31.8557785 0.984484839,31.7323669 0.984484839,31.5495661 L0.984484839,31.2204684 C0.984484839,31.0376676 1.04850724,30.8502336 1.17641165,30.6583068 C1.30445645,30.46638 1.45973886,30.3247164 1.64253967,30.233316 L3.23313133,29.4380904 L3.23313133,15.1786446 L1.64253967,15.9738702 C1.45973886,16.065411 1.30445645,16.0790298 1.17641165,16.0151478 C1.04850724,15.9511254 0.984484839,15.8277138 0.984484839,15.644913 L0.984484839,15.3158154 C0.984484839,15.1330146 1.04850724,14.9455806 1.17641165,14.7536538 C1.30445645,14.561727 1.45973886,14.4200634 1.64253967,14.328663 L6.79788747,11.7509189 C6.98068828,11.6595185 7.13611108,11.6458997 7.26401549,11.7099221 C7.39206029,11.7738041 7.4560827,11.8972157 7.4560827,12.0800165 L7.4560827,12.4091141 C7.4560827,12.5919149 7.39206029,12.7793489 7.26401549,12.9712757 C7.13611108,13.1632025 6.98068828,13.3048661 6.79788747,13.3962665 L5.20743621,14.1914922 L5.20743621,20.4436448 L14.969589,15.5626386 L14.969589,9.31048597 L13.3791377,10.1057116 C13.1963369,10.197112 13.0409141,10.2107308 12.9130097,10.1468488 C12.7849649,10.0828264 12.7210829,9.9594148 12.7210829,9.77661399 L12.7210829,9.44751638 Z M28.4062907,0.946857638 C28.5890915,0.855316834 28.7445143,0.841698033 28.8724187,0.905720436 C29.0004636,0.969602439 29.064486,1.09301404 29.064486,1.27581485 L29.064486,16.4127607 L32.1904921,14.8496874 C32.3732929,14.758287 32.5287157,14.7445278 32.6566201,14.8085502 C32.7846649,14.8725726 32.8486873,14.9958438 32.8486873,15.178785 L32.8486873,15.617535 C32.8486873,15.8003358 32.7846649,15.9876294 32.6566201,16.1795562 C32.5287157,16.3716235 32.3732929,16.5132871 32.1904921,16.6046875 L23.9091382,20.7453644 C23.7263373,20.8367648 23.5709145,20.850524 23.4430101,20.7865016 C23.3149653,20.7224792 23.2509429,20.5990676 23.2509429,20.4162668 L23.2509429,19.9775168 C23.2509429,19.794716 23.3149653,19.607282 23.4430101,19.4153552 C23.5709145,19.2234284 23.7263373,19.0817648 23.9091382,18.9903644 L27.1449371,17.3723947 L27.1449371,4.10024176 C27.0077663,4.36082417 26.8398479,4.64695938 26.6410415,4.9589282 L25.005943,7.4732115 C24.8597866,7.6560123 24.6952378,7.79304271 24.512437,7.88444311 C24.3296362,7.97598392 24.1833394,7.97598392 24.073687,7.88444311 L23.7445893,7.77479071 C23.5982925,7.70164231 23.5251441,7.5737379 23.5251441,7.39093709 C23.5251441,7.20813629 23.5982925,7.02533548 23.7445893,6.84253467 L27.0900407,1.76946127 C27.2363375,1.58666046 27.4008863,1.44948966 27.5836871,1.35808925 L28.4062907,0.946857638 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-7",
    d: "M18.59928,22.58354 L14.5523,28.59906 C14.44296,28.79954 14.29708,28.94542 14.1148,29.03656 C13.93252,29.1277 13.78678,29.1277 13.6773,29.03656 L9.63046,27.06788 C9.52112,26.97674 9.46638,26.83996 9.46638,26.65768 C9.46638,26.4754 9.52112,26.30222 9.63046,26.13814 L10.01336,25.564 C10.1591,25.34518 10.32318,25.1902 10.50546,25.09906 C10.68774,25.00792 10.83362,25.00792 10.94296,25.09906 L13.1852,26.22018 L13.2398,26.19288 L13.2398,16.3492 L3.39612,21.27104 L3.39612,21.32564 L5.63836,22.44676 C5.7841,22.48316 5.85704,22.59264 5.85704,22.77492 C5.85704,22.9572 5.7841,23.15768 5.63836,23.3765 L5.25546,23.95064 C5.14612,24.11472 5.00024,24.24226 4.81796,24.33354 C4.63568,24.42468 4.4716,24.45198 4.32586,24.41544 L0.33362,22.36472 C0.18774,22.32832 0.11494,22.21884 0.11494,22.03656 C0.11494,21.85428 0.18774,21.672 0.33362,21.48972 L4.32586,15.4462 C4.4716,15.2642 4.63568,15.1284 4.81796,15.036 C5.00024,14.945 5.14612,14.9268 5.25546,14.9814 L5.63836,15.1732 C5.7841,15.246 5.85704,15.3734 5.85704,15.5568 C5.85704,15.7388 5.7841,15.9208 5.63836,16.1028 L3.39612,19.467 L3.39612,19.5216 L13.2398,14.5992 L13.2398,4.7558 L13.1852,4.7824 L10.94296,8.1466 C10.83362,8.3468 10.68774,8.4924 10.50546,8.5834 C10.32318,8.6744 10.1591,8.6842 10.01336,8.6114 L9.63046,8.4196 C9.52112,8.365 9.46638,8.246 9.46638,8.064 C9.46638,7.882 9.52112,7.6902 9.63046,7.49 L13.6773,1.4742 C13.78678,1.274 13.93252,1.1284 14.1148,1.036 C14.29708,0.945 14.44296,0.945 14.5523,1.036 L18.59928,3.0058 C18.70862,3.0968 18.76322,3.2326 18.76322,3.416 C18.76322,3.598 18.70862,3.7716 18.59928,3.9354 L18.21638,4.5094 C18.07064,4.7278 17.90656,4.8832 17.72428,4.9742 C17.542,5.0652 17.39612,5.0652 17.28678,4.9742 L15.04454,3.8528 L14.9898,3.8808 L14.9898,13.7242 L24.83362,8.8018 L24.83362,8.7472 L22.59138,7.6258 C22.4455,7.5894 22.3727,7.4802 22.3727,7.2982 C22.3727,7.1162 22.4455,6.916 22.59138,6.6962 L22.97428,6.1222 C23.08362,5.9584 23.22936,5.831 23.41178,5.74 C23.59406,5.649 23.758,5.621 23.90388,5.6574 L27.89612,7.7084 C28.04186,7.7448 28.1148,7.854 28.1148,8.036 C28.1148,8.2194 28.04186,8.4014 27.89612,8.5834 L23.90388,14.6258 C23.758,14.8092 23.59406,14.945 23.41178,15.036 C23.22936,15.1284 23.08362,15.1466 22.97428,15.092 L22.59138,14.9002 C22.4455,14.8274 22.3727,14.7 22.3727,14.5166 C22.3727,14.3346 22.4455,14.1526 22.59138,13.9706 L24.83362,10.6064 L24.83362,10.5518 L14.9898,15.4742 L14.9898,25.31788 L15.04454,25.29044 L17.28678,21.92722 C17.39612,21.72674 17.542,21.58086 17.72428,21.48972 C17.90656,21.39858 18.07064,21.38948 18.21638,21.46242 L18.59928,21.6538 C18.70862,21.70854 18.76322,21.82698 18.76322,22.00926 C18.76322,22.19154 18.70862,22.38292 18.59928,22.58354 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-9",
    d: "M15.869,6.12528 C14.7868,5.58404 13.5086,5.2157 12.0358,5.02026 C10.563,4.82482 9.0888,4.82482 7.616,5.02026 C6.1432,5.2157 4.865,5.58404 3.7828,6.12528 L1.8886,7.07238 C1.2866,7.3731 0.9856,7.73388 0.9856,8.15486 C0.9856,8.5757 1.2866,8.93648 1.8886,9.2372 L17.7632,17.17492 C18.3652,17.4755 19.0862,17.62586 19.9276,17.62586 C20.7704,17.62586 21.4914,17.4755 22.0934,17.17492 L23.9876,16.22782 C25.0698,15.68658 25.8062,15.04762 26.1968,14.31094 C26.5888,13.5744 26.5888,12.83772 26.1968,12.10104 C25.8062,11.3645 25.0698,10.72554 23.9876,10.1843 C23.597,9.98886 22.9796,9.78586 22.1382,9.57544 L21.539,9.4059 C21.2646,9.32652 21.0294,9.25526 20.8306,9.19212 C20.2888,9.01166 19.7484,8.78626 19.2066,8.51564 C18.6648,8.24502 18.214,7.9744 17.8542,7.70378 C17.6428,7.53844 17.388,7.32046 17.087,7.04984 C16.6656,6.62886 16.2596,6.32072 15.869,6.12528 Z M3.332,7.79394 L5.2262,6.84684 C6.489,6.21544 8.022,5.89974 9.8252,5.89974 C11.6298,5.89974 13.1628,6.21544 14.4256,6.84684 C14.6664,6.9671 14.9674,7.19264 15.3286,7.52332 C16.0202,8.19994 16.8308,8.77114 17.7632,9.2372 C18.6956,9.70326 19.838,10.10912 21.1904,10.45492 C21.8526,10.63538 22.3034,10.7856 22.5442,10.90586 C23.807,11.53726 24.4384,12.30404 24.4384,13.20606 C24.4384,14.10808 23.807,14.87472 22.5442,15.50612 L20.65,16.45322 C20.44,16.5585 20.1992,16.61114 19.9276,16.61114 C19.6574,16.61114 19.4166,16.5585 19.2066,16.45322 L3.332,8.51564 C3.1206,8.41036 3.0156,8.2901 3.0156,8.15486 C3.0156,8.01948 3.1206,7.89922 3.332,7.79394 Z M21.371,7.43316 C22.4238,7.95942 23.6488,8.31642 25.0474,8.5043 C26.4446,8.69218 27.8432,8.69218 29.2418,8.5043 C30.639,8.31642 31.8654,7.95942 32.9168,7.43316 C33.9696,6.90704 34.6836,6.2944 35.0588,5.59538 C35.4354,4.89622 35.4354,4.1972 35.0588,3.49818 C34.6836,2.79916 33.9696,2.18652 32.9168,1.66026 C31.8654,1.13414 30.639,0.77714 29.2418,0.58926 C27.8432,0.40124 26.4446,0.40124 25.0474,0.58926 C23.6488,0.77714 22.4238,1.13414 21.371,1.66026 C20.3196,2.18652 19.6056,2.79916 19.229,3.49818 C18.8538,4.1972 18.8538,4.89622 19.229,5.59538 C19.6056,6.2944 20.3196,6.90704 21.371,7.43316 Z M31.4734,2.38196 C30.2708,1.78066 28.8274,1.47994 27.1446,1.47994 C25.4604,1.47994 24.017,1.78066 22.8144,2.38196 C21.6118,2.98326 21.0112,3.70482 21.0112,4.54678 C21.0112,5.3886 21.6118,6.1103 22.8144,6.7116 C24.017,7.3129 25.4604,7.61362 27.1446,7.61362 C28.8274,7.61362 30.2708,7.3129 31.4734,6.7116 C32.676,6.1103 33.278,5.3886 33.278,4.54678 C33.278,3.70482 32.676,2.98326 31.4734,2.38196 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-11",
    d: "M15.2386,6.4778 C14.155,5.936 12.8782,5.5678 11.404,5.3718 C9.9312,5.1772 8.4584,5.1772 6.9842,5.3718 C5.5114,5.5678 4.2332,5.936 3.151,6.4778 L1.2568,7.4242 C0.6562,7.7252 0.3552,8.0864 0.3552,8.5064 C0.3552,8.9278 0.6562,9.289 1.2568,9.59 L17.1328,17.5266 C17.7334,17.8276 18.4558,17.9774 19.2972,17.9774 C20.1386,17.9774 20.861,17.8276 21.4616,17.5266 L23.3558,16.5802 C24.438,16.0384 25.1744,15.4 25.5664,14.6636 C25.957,13.9258 25.957,13.1894 25.5664,12.453 C25.1744,11.7166 24.438,11.0782 23.3558,10.5364 C22.9652,10.3404 22.3492,10.1374 21.5064,9.9274 L20.9086,9.758 C20.6342,9.6782 20.3976,9.6068 20.1988,9.5438 C19.6584,9.3632 19.1166,9.1378 18.5748,8.8676 C18.0344,8.5974 17.5836,8.3272 17.2224,8.0556 C17.0124,7.8904 16.7562,7.672 16.4552,7.4018 C16.0352,6.9804 15.6292,6.6724 15.2386,6.4778 Z M2.7002,8.1466 L4.5944,7.1988 C5.8572,6.5674 7.3902,6.2524 9.1948,6.2524 C10.998,6.2524 12.5324,6.5674 13.7952,7.1988 C14.0346,7.3192 14.3356,7.5446 14.6968,7.875 C15.3884,8.5526 16.2004,9.1238 17.1328,9.59 C18.0638,10.0548 19.2062,10.4608 20.56,10.8066 C21.2208,10.9872 21.6716,11.1384 21.9124,11.2574 C23.1752,11.8888 23.8066,12.656 23.8066,13.5576 C23.8066,14.4606 23.1752,15.2264 21.9124,15.8578 L20.0182,16.8056 C19.8082,16.9106 19.5674,16.9638 19.2972,16.9638 C19.027,16.9638 18.7862,16.9106 18.5748,16.8056 L2.7002,8.8676 C2.4902,8.7626 2.3838,8.6422 2.3838,8.5064 C2.3838,8.372 2.4902,8.2516 2.7002,8.1466 Z M20.7406,7.7854 C21.792,8.3118 23.0184,8.6688 24.4156,8.8564 C25.8142,9.044 27.2128,9.044 28.61,8.8564 C30.0086,8.6688 31.2336,8.3118 32.2864,7.7854 C33.3378,7.259 34.0518,6.6472 34.4284,5.9472 C34.8036,5.2486 34.8036,4.55 34.4284,3.85 C34.0518,3.1514 33.3378,2.5382 32.2864,2.0118 C31.2336,1.4868 30.0086,1.1298 28.61,0.9408 C27.2128,0.7532 25.8142,0.7532 24.4156,0.9408 C23.0184,1.1298 21.792,1.4868 20.7406,2.0118 C19.6878,2.5382 18.9738,3.1514 18.5986,3.85 C18.222,4.55 18.222,5.2486 18.5986,5.9472 C18.9738,6.6472 19.6878,7.259 20.7406,7.7854 Z M30.843,2.7342 C29.6404,2.1322 28.197,1.8326 26.5128,1.8326 C24.83,1.8326 23.3866,2.1322 22.184,2.7342 C20.9814,3.3348 20.3794,4.0572 20.3794,4.8986 C20.3794,5.7414 20.9814,6.4624 22.184,7.0644 C23.3866,7.665 24.83,7.966 26.5128,7.966 C28.197,7.966 29.6404,7.665 30.843,7.0644 C32.0456,6.4624 32.6462,5.7414 32.6462,4.8986 C32.6462,4.0572 32.0456,3.3348 30.843,2.7342 Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-13",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "6.488%",
    stopColor: "#00FFFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFF6"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-14",
    cx: 43,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-15",
    width: "700%",
    height: "700%",
    x: "-300%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-16",
    cx: 7,
    cy: 26,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-17",
    width: "700%",
    height: "700%",
    x: "-300%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 1   0 0 0 0 0.964555503   0 0 0 0 0.67496189  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-18",
    cx: 41,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-19",
    width: "700%",
    height: "700%",
    x: "-300%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-20",
    cx: 33,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-21",
    width: "400%",
    height: "400%",
    x: "-150%",
    y: "-150%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 1   0 0 0 0 0.964555503   0 0 0 0 0.67496189  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-22",
    cx: 2,
    cy: 42,
    r: 2
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-23",
    width: "400%",
    height: "400%",
    x: "-150%",
    y: "-150%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-24",
    cx: 36.5,
    cy: 29.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-25",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-26",
    cx: 16.5,
    cy: 0.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-27",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 1   0 0 0 0 0.964555503   0 0 0 0 0.67496189  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-28",
    cx: 8.5,
    cy: 16.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-29",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-30",
    d: "M11.06,4.76 C10.2662,4.3638 9.3296,4.0936 8.2488,3.9508 C7.1694,3.8066 6.0886,3.8066 5.0078,3.9508 C3.9284,4.0936 2.9904,4.3638 2.1966,4.76 L0.8078,5.4544 C0.3668,5.6756 0.147,5.9402 0.147,6.2482 C0.147,6.5576 0.3668,6.8222 0.8078,7.042 L12.4488,12.8618 C12.8898,13.083 13.419,13.1936 14.0364,13.1936 C14.6538,13.1936 15.183,13.083 15.624,12.8618 L17.0128,12.1674 C17.8066,11.7712 18.3456,11.3022 18.6326,10.7618 C18.9196,10.2228 18.9196,9.6824 18.6326,9.142 C18.3456,8.6016 17.8066,8.134 17.0128,7.7364 C16.7258,7.5936 16.2736,7.4452 15.6562,7.2898 L15.218,7.1652 C15.0164,7.1078 14.8428,7.056 14.6972,7.0098 C14.301,6.8768 13.9034,6.7116 13.5072,6.5128 C13.1096,6.314 12.7792,6.1166 12.5146,5.9178 C12.3606,5.796 12.173,5.6364 11.9532,5.439 C11.6438,5.1296 11.347,4.9042 11.06,4.76 Z M1.8662,5.9836 L3.255,5.2892 C4.1818,4.8272 5.306,4.5948 6.629,4.5948 C7.952,4.5948 9.0762,4.8272 10.0016,5.2892 C10.178,5.3774 10.3978,5.5426 10.6624,5.7862 C11.1706,6.2818 11.7656,6.7004 12.4488,7.042 C13.132,7.3836 13.9706,7.6818 14.9618,7.9352 C15.4476,8.0668 15.778,8.1774 15.9544,8.2656 C16.8798,8.729 17.3432,9.2904 17.3432,9.9526 C17.3432,10.6134 16.8798,11.1762 15.9544,11.6382 L14.5656,12.3326 C14.4116,12.411 14.2352,12.4488 14.0364,12.4488 C13.8376,12.4488 13.6612,12.411 13.5072,12.3326 L1.8662,6.5128 C1.7122,6.4358 1.6352,6.3476 1.6352,6.2482 C1.6352,6.1488 1.7122,6.0606 1.8662,5.9836 Z M15.0948,5.719 C15.8662,6.1054 16.765,6.3672 17.7898,6.5044 C18.8146,6.643 19.8394,6.643 20.8656,6.5044 C21.8904,6.3672 22.7878,6.1054 23.5606,5.719 C24.332,5.334 24.8556,4.8846 25.1314,4.3722 C25.4058,3.8598 25.4058,3.346 25.1314,2.8336 C24.8556,2.3212 24.332,1.8718 23.5606,1.4868 C22.7878,1.1004 21.8904,0.8386 20.8656,0.7014 C19.8394,0.5628 18.8146,0.5628 17.7898,0.7014 C16.765,0.8386 15.8662,1.1004 15.0948,1.4868 C14.3234,1.8718 13.7998,2.3212 13.524,2.8336 C13.2482,3.346 13.2482,3.8598 13.524,4.3722 C13.7998,4.8846 14.3234,5.334 15.0948,5.719 Z M22.5022,2.016 C21.6202,1.575 20.5618,1.3538 19.327,1.3538 C18.0922,1.3538 17.0338,1.575 16.1532,2.016 C15.2712,2.457 14.8302,2.9862 14.8302,3.6036 C14.8302,4.2196 15.2712,4.7488 16.1532,5.1898 C17.0338,5.6308 18.0922,5.852 19.327,5.852 C20.5618,5.852 21.6202,5.6308 22.5022,5.1898 C23.3842,4.7488 23.8252,4.2196 23.8252,3.6036 C23.8252,2.9862 23.3842,2.457 22.5022,2.016 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-32",
    d: "M15.7738,5.9416 C14.6916,5.3998 13.4134,5.0316 11.9406,4.8356 C10.4664,4.641 8.9936,4.641 7.5208,4.8356 C6.0466,5.0316 4.7698,5.3998 3.6862,5.9416 L1.792,6.888 C1.1914,7.189 0.8904,7.5502 0.8904,7.9702 C0.8904,8.3916 1.1914,8.7528 1.792,9.0524 L17.668,16.9904 C18.2686,17.2914 18.991,17.4412 19.8324,17.4412 C20.6752,17.4412 21.3962,17.2914 21.9982,16.9904 L23.8924,16.044 C24.9746,15.5022 25.711,14.8638 26.1016,14.1274 C26.4922,13.3896 26.4922,12.6532 26.1016,11.9168 C25.711,11.1804 24.9746,10.542 23.8924,10.0002 C23.5004,9.8042 22.8844,9.6012 22.043,9.3912 L21.4438,9.2218 C21.1694,9.142 20.9328,9.0706 20.7354,9.0076 C20.1936,8.827 19.6518,8.6016 19.1114,8.3314 C18.5696,8.0612 18.1188,7.7896 17.7576,7.5194 C17.5476,7.3542 17.2914,7.1358 16.9918,6.8656 C16.5704,6.4442 16.1644,6.1362 15.7738,5.9416 Z M3.2354,7.6104 L5.1296,6.6626 C6.3924,6.0312 7.9268,5.7162 9.73,5.7162 C11.5346,5.7162 13.0676,6.0312 14.3304,6.6626 C14.5712,6.783 14.8722,7.0084 15.232,7.3388 C15.9236,8.0164 16.7356,8.5876 17.668,9.0524 C18.6004,9.5186 19.7428,9.9246 21.0952,10.2704 C21.7574,10.451 22.2082,10.6022 22.449,10.7212 C23.7118,11.3526 24.3432,12.1198 24.3432,13.0214 C24.3432,13.9244 23.7118,14.6902 22.449,15.3216 L20.5548,16.2694 C20.3434,16.3744 20.104,16.4276 19.8324,16.4276 C19.5622,16.4276 19.3214,16.3744 19.1114,16.2694 L3.2354,8.3314 C3.0254,8.2264 2.9204,8.106 2.9204,7.9702 C2.9204,7.8358 3.0254,7.7154 3.2354,7.6104 Z M21.2758,7.2492 C22.3286,7.7756 23.5536,8.1326 24.9522,8.3202 C26.3494,8.5078 27.748,8.5078 29.1466,8.3202 C30.5438,8.1326 31.7688,7.7756 32.8216,7.2492 C33.8744,6.7228 34.5884,6.1096 34.9636,5.411 C35.3402,4.7124 35.3402,4.0138 34.9636,3.3138 C34.5884,2.6152 33.8744,2.002 32.8216,1.4756 C31.7688,0.9506 30.5438,0.5936 29.1466,0.4046 C27.748,0.217 26.3494,0.217 24.9522,0.4046 C23.5536,0.5936 22.3286,0.9506 21.2758,1.4756 C20.223,2.002 19.509,2.6152 19.1338,3.3138 C18.7572,4.0138 18.7572,4.7124 19.1338,5.411 C19.509,6.1096 20.223,6.7228 21.2758,7.2492 Z M31.3782,2.198 C30.1756,1.596 28.7322,1.2964 27.0494,1.2964 C25.3652,1.2964 23.9218,1.596 22.7192,2.198 C21.5166,2.7986 20.9146,3.521 20.9146,4.3624 C20.9146,5.2052 21.5166,5.9262 22.7192,6.5268 C23.9218,7.1288 25.3652,7.4298 27.0494,7.4298 C28.7322,7.4298 30.1756,7.1288 31.3782,6.5268 C32.5808,5.9262 33.1828,5.2052 33.1828,4.3624 C33.1828,3.521 32.5808,2.7986 31.3782,2.198 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-34",
    d: "M9.787,4.074 C9.101,3.689 8.2918,3.4272 7.3594,3.2886 C6.4256,3.1486 5.4932,3.1486 4.5594,3.2886 C3.627,3.4272 2.8178,3.689 2.1318,4.074 L0.932,4.7474 C0.5512,4.9616 0.3608,5.2178 0.3608,5.5174 C0.3608,5.817 0.5512,6.0732 0.932,6.2874 L10.9868,11.9308 C11.3676,12.145 11.824,12.2528 12.3574,12.2528 C12.8908,12.2528 13.3472,12.145 13.728,11.9308 L14.9278,11.2574 C15.6138,10.8724 16.08,10.4188 16.3278,9.8952 C16.5742,9.3716 16.5742,8.8466 16.3278,8.323 C16.08,7.7994 15.6138,7.3458 14.9278,6.9608 C14.68,6.8208 14.2894,6.6766 13.756,6.5268 L13.378,6.4064 C13.203,6.3504 13.0546,6.3 12.9286,6.2552 C12.5856,6.1264 12.2426,5.9654 11.8996,5.7736 C11.558,5.5818 11.2724,5.3886 11.0428,5.1968 C10.9098,5.0792 10.7488,4.9238 10.5584,4.7306 C10.291,4.4324 10.0348,4.2126 9.787,4.074 Z M1.8462,5.2598 L3.046,4.5864 C3.8454,4.1384 4.817,3.913 5.9594,3.913 C7.1018,3.913 8.0734,4.1384 8.8728,4.5864 C9.0254,4.6718 9.2158,4.8328 9.444,5.068 C9.8822,5.5496 10.396,5.9556 10.9868,6.2874 C11.5762,6.6178 12.3,6.9062 13.1568,7.1526 C13.5754,7.2814 13.861,7.3878 14.0136,7.4732 C14.813,7.9226 15.2134,8.4672 15.2134,9.1084 C15.2134,9.751 14.813,10.2956 14.0136,10.745 L12.8138,11.4184 C12.6808,11.4926 12.5282,11.5304 12.3574,11.5304 C12.1852,11.5304 12.034,11.4926 11.8996,11.4184 L1.8462,5.7736 C1.7132,5.6994 1.646,5.6126 1.646,5.5174 C1.646,5.4208 1.7132,5.3354 1.8462,5.2598 Z M13.2716,5.0036 C13.938,5.3774 14.7136,5.6322 15.5984,5.7652 C16.4846,5.8996 17.3694,5.8996 18.2556,5.7652 C19.1404,5.6322 19.916,5.3774 20.5824,5.0036 C21.2488,4.6298 21.701,4.1944 21.939,3.6974 C22.177,3.2004 22.177,2.7034 21.939,2.205 C21.701,1.708 21.2488,1.2726 20.5824,0.8988 C19.916,0.525 19.1404,0.2702 18.2556,0.1372 C17.3694,0.0028 16.4846,0.0028 15.5984,0.1372 C14.7136,0.2702 13.938,0.525 13.2716,0.8988 C12.6052,1.2726 12.153,1.708 11.915,2.205 C11.677,2.7034 11.677,3.2004 11.915,3.6974 C12.153,4.1944 12.6052,4.6298 13.2716,5.0036 Z M19.6682,1.4112 C18.9066,0.9842 17.9938,0.77 16.927,0.77 C15.8602,0.77 14.946,0.9842 14.1844,1.4112 C13.4228,1.8396 13.042,2.352 13.042,2.9512 C13.042,3.5504 13.4228,4.0628 14.1844,4.4912 C14.946,4.9182 15.8602,5.1324 16.927,5.1324 C17.9938,5.1324 18.9066,4.9182 19.6682,4.4912 C20.4298,4.0628 20.8106,3.5504 20.8106,2.9512 C20.8106,2.352 20.4298,1.8396 19.6682,1.4112 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-36",
    d: "M7.4896,3.4034 C6.9576,3.1052 6.3318,2.9022 5.6094,2.7944 C4.887,2.6866 4.1646,2.6866 3.4422,2.7944 C2.7198,2.9022 2.0926,3.1052 1.562,3.4034 L0.6338,3.9242 C0.3384,4.0894 0.1914,4.28848 0.1914,4.52018 C0.1914,4.75202 0.3384,4.95068 0.6338,5.11616 L8.4178,9.48696 C8.7132,9.65244 9.066,9.73532 9.479,9.73532 C9.892,9.73532 10.2462,9.65244 10.5416,9.48696 L11.4698,8.96546 C12.0004,8.6674 12.3616,8.31558 12.5534,7.91 C12.7452,7.50442 12.7452,7.0987 12.5534,6.69312 C12.3616,6.28754 12.0004,5.93572 11.4698,5.63766 C11.278,5.53014 10.9756,5.41842 10.5626,5.3025 L10.27,5.20912 C10.1356,5.16544 10.0194,5.1261 9.9214,5.09138 C9.6568,4.99212 9.3908,4.86794 9.1262,4.71884 C8.8602,4.56988 8.639,4.42092 8.4626,4.27182 C8.359,4.1804 8.233,4.0614 8.086,3.9116 C7.8802,3.6806 7.6814,3.5098 7.4896,3.4034 Z M1.3408,4.32152 L2.2704,3.7996 C2.8892,3.4524 3.641,3.2788 4.5258,3.2788 C5.4106,3.2788 6.1624,3.4524 6.7812,3.7996 C6.8988,3.8668 7.0472,3.99 7.2236,4.172 C7.5624,4.5451 7.9614,4.85968 8.4178,5.11616 C8.8756,5.37278 9.4356,5.59636 10.0992,5.78676 C10.4226,5.88602 10.6438,5.9689 10.7628,6.03512 C11.3816,6.38274 11.691,6.80484 11.691,7.30156 C11.691,7.79828 11.3816,8.22038 10.7628,8.56814 L9.8332,9.08964 C9.7296,9.14746 9.612,9.17644 9.479,9.17644 C9.3474,9.17644 9.2284,9.14746 9.1262,9.08964 L1.3408,4.71884 C1.2372,4.66088 1.1868,4.59466 1.1868,4.52018 C1.1868,4.4457 1.2372,4.37948 1.3408,4.32152 Z M10.1874,4.123 C10.7026,4.41266 11.3046,4.60922 11.9892,4.71268 C12.6752,4.81614 13.3612,4.81614 14.0458,4.71268 C14.7318,4.60922 15.3324,4.41266 15.849,4.123 C16.3642,3.8332 16.7142,3.4958 16.899,3.1108 C17.0838,2.7258 17.0838,2.3408 16.899,1.9558 C16.7142,1.5708 16.3642,1.2334 15.849,0.9436 C15.3324,0.6538 14.7318,0.4578 14.0458,0.3542 C13.3612,0.2506 12.6752,0.2506 11.9892,0.3542 C11.3046,0.4578 10.7026,0.6538 10.1874,0.9436 C9.6708,1.2334 9.3208,1.5708 9.136,1.9558 C8.9526,2.3408 8.9526,2.7258 9.136,3.1108 C9.3208,3.4958 9.6708,3.8332 10.1874,4.123 Z M15.1406,1.3412 C14.5512,1.0108 13.8442,0.8442 13.0182,0.8442 C12.1922,0.8442 11.4852,1.0108 10.8944,1.3412 C10.305,1.673 10.0096,2.0706 10.0096,2.534 C10.0096,2.9974 10.305,3.395 10.8944,3.7254 C11.4852,4.0572 12.1922,4.22226 13.0182,4.22226 C13.8442,4.22226 14.5512,4.0572 15.1406,3.7254 C15.7314,3.395 16.0254,2.9974 16.0254,2.534 C16.0254,2.0706 15.7314,1.673 15.1406,1.3412 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-38",
    d: "M9.5354,4.23852 C8.8452,3.85086 8.0304,3.58696 7.0896,3.44696 C6.1502,3.30696 5.2108,3.30696 4.27,3.44696 C3.3306,3.58696 2.5158,3.85072 1.8256,4.23852 L0.616,4.91696 C0.2324,5.13228 0.0406,5.39072 0.0406,5.69228 C0.0406,5.99384 0.2324,6.25228 0.616,6.46774 L10.7436,12.15384 C11.1272,12.36916 11.5878,12.47696 12.1254,12.47696 C12.6616,12.47696 13.1222,12.36916 13.5058,12.15384 L14.714,11.4754 C15.4056,11.0876 15.8746,10.62994 16.1238,10.10228 C16.3744,9.57462 16.3744,9.04696 16.1238,8.51916 C15.8746,7.9915 15.4056,7.53384 14.714,7.14618 C14.4648,7.00618 14.0714,6.86072 13.5352,6.70994 L13.153,6.58856 C12.978,6.53172 12.8268,6.48062 12.7008,6.4354 C12.355,6.30618 12.0106,6.14462 11.6648,5.95072 C11.319,5.75696 11.032,5.56306 10.801,5.3693 C10.668,5.25072 10.5042,5.09462 10.3124,4.90072 C10.0436,4.5993 9.7846,4.37852 9.5354,4.23852 Z M1.5372,5.43384 L2.7454,4.7554 C3.5518,4.30306 4.529,4.07696 5.6798,4.07696 C6.8306,4.07696 7.8092,4.30306 8.6156,4.7554 C8.7682,4.8415 8.96,5.00306 9.191,5.24008 C9.632,5.72462 10.15,6.13384 10.7436,6.46774 C11.3386,6.8015 12.068,7.09228 12.9304,7.33994 C13.3532,7.46916 13.6402,7.57696 13.7942,7.66306 C14.5992,8.1154 15.0024,8.66462 15.0024,9.31072 C15.0024,9.95696 14.5992,10.50618 13.7942,10.95838 L12.586,11.63696 C12.4516,11.71228 12.2976,11.74994 12.1254,11.74994 C11.9532,11.74994 11.7992,11.71228 11.6648,11.63696 L1.5372,5.95072 C1.4028,5.8754 1.3356,5.7893 1.3356,5.69228 C1.3356,5.5954 1.4028,5.5093 1.5372,5.43384 Z M13.0452,5.1754 C13.7172,5.55228 14.4984,5.80806 15.3902,5.94274 C16.282,6.07728 17.1752,6.07728 18.067,5.94274 C18.9588,5.80806 19.74,5.55228 20.4106,5.1754 C21.0826,4.79852 21.5376,4.35962 21.7784,3.85884 C22.0178,3.35806 22.0178,2.85728 21.7784,2.3565 C21.5376,1.85586 21.0826,1.41696 20.4106,1.04008 C19.74,0.66306 18.9588,0.40742 18.067,0.27274 C17.1752,0.13806 16.282,0.13806 15.3902,0.27274 C14.4984,0.40742 13.7172,0.66306 13.0452,1.04008 C12.3746,1.41696 11.9196,1.85586 11.6788,2.3565 C11.4394,2.85728 11.4394,3.35806 11.6788,3.85884 C11.9196,4.35962 12.3746,4.79852 13.0452,5.1754 Z M19.4908,1.55696 C18.7236,1.12618 17.8024,0.91086 16.7286,0.91086 C15.6548,0.91086 14.7336,1.12618 13.9664,1.55696 C13.1992,1.98774 12.8156,2.50462 12.8156,3.10774 C12.8156,3.71086 13.1992,4.22774 13.9664,4.65852 C14.7336,5.0893 15.6548,5.30462 16.7286,5.30462 C17.8024,5.30462 18.7236,5.0893 19.4908,4.65852 C20.258,4.22774 20.6416,3.71086 20.6416,3.10774 C20.6416,2.50462 20.258,1.98774 19.4908,1.55696 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-40",
    d: "M15.484,5.78622 C14.4004,5.24512 13.1236,4.87678 11.6494,4.68134 C10.1766,4.4859 8.7038,4.4859 7.2296,4.68134 C5.7568,4.87678 4.4786,5.24512 3.3964,5.78622 L1.5022,6.73332 C0.9016,7.03404 0.6006,7.39482 0.6006,7.8158 C0.6006,8.23678 0.9016,8.59756 1.5022,8.89814 L17.3782,16.83586 C17.9788,17.13658 18.7012,17.2868 19.5426,17.2868 C20.384,17.2868 21.1064,17.13658 21.707,16.83586 L23.6012,15.88876 C24.6834,15.34752 25.4212,14.70856 25.8118,13.97202 C26.2024,13.23534 26.2024,12.49866 25.8118,11.76212 C25.4212,11.02544 24.6834,10.38648 23.6012,9.84524 C23.2106,9.6498 22.5946,9.44694 21.7518,9.23638 L21.154,9.06684 C20.8796,8.98746 20.643,8.9162 20.4442,8.85306 C19.9038,8.67274 19.362,8.4472 18.8216,8.17658 C18.2798,7.90596 17.829,7.63534 17.4678,7.36472 C17.2578,7.19938 17.0016,6.9814 16.7006,6.71078 C16.2806,6.28994 15.8746,5.98166 15.484,5.78622 Z M2.9456,7.45502 L4.8398,6.50792 C6.1026,5.87652 7.6356,5.56082 9.4402,5.56082 C11.2434,5.56082 12.7778,5.87652 14.0406,6.50792 C14.2814,6.62818 14.581,6.85358 14.9422,7.1844 C15.6338,7.86088 16.4458,8.43222 17.3782,8.89814 C18.3092,9.3642 19.453,9.7702 20.8054,10.11586 C21.4662,10.29632 21.9184,10.44668 22.1578,10.56694 C23.4206,11.19834 24.052,11.96498 24.052,12.867 C24.052,13.76902 23.4206,14.5358 22.1578,15.1672 L20.2636,16.1143 C20.0536,16.21944 19.8128,16.27208 19.5426,16.27208 C19.2724,16.27208 19.0316,16.21944 18.8216,16.1143 L2.9456,8.17658 C2.7356,8.0713 2.6292,7.95104 2.6292,7.8158 C2.6292,7.68042 2.7356,7.56016 2.9456,7.45502 Z M20.986,7.09424 C22.0374,7.62036 23.2638,7.97736 24.661,8.16538 C26.0596,8.35326 27.4582,8.35326 28.8554,8.16538 C30.254,7.97736 31.479,7.62036 32.5318,7.09424 C33.5832,6.56798 34.2972,5.95534 34.6738,5.25632 C35.049,4.5573 35.049,3.85828 34.6738,3.15912 C34.2972,2.4601 33.5832,1.84746 32.5318,1.32134 C31.479,0.79508 30.254,0.43808 28.8554,0.2502 C27.4582,0.06232 26.0596,0.06232 24.661,0.2502 C23.2638,0.43808 22.0374,0.79508 20.986,1.32134 C19.9332,1.84746 19.2192,2.4601 18.844,3.15912 C18.4674,3.85828 18.4674,4.5573 18.844,5.25632 C19.2192,5.95534 19.9332,6.56798 20.986,7.09424 Z M31.0884,2.0429 C29.8858,1.4416 28.4424,1.14088 26.7582,1.14088 C25.0754,1.14088 23.632,1.4416 22.4294,2.0429 C21.2268,2.6442 20.6248,3.3659 20.6248,4.20772 C20.6248,5.04968 21.2268,5.77124 22.4294,6.37254 C23.632,6.97384 25.0754,7.27456 26.7582,7.27456 C28.4424,7.27456 29.8858,6.97384 31.0884,6.37254 C32.291,5.77124 32.8916,5.04968 32.8916,4.20772 C32.8916,3.3659 32.291,2.6442 31.0884,2.0429 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-42",
    d: "M10.787,3.7789 C10.0674,3.41924 9.2176,3.17452 8.239,3.0446 C7.259,2.91468 6.2804,2.91468 5.3018,3.0446 C4.3218,3.17452 3.4734,3.41924 2.7538,3.7789 L1.4952,4.40834 C1.0948,4.60826 0.8946,4.84794 0.8946,5.1278 C0.8946,5.40752 1.0948,5.64734 1.4952,5.84712 L12.0456,11.12246 C12.4446,11.32224 12.9248,11.4222 13.4834,11.4222 C14.0434,11.4222 14.5236,11.32224 14.9226,11.12246 L16.1812,10.49302 C16.9008,10.13336 17.3908,9.70874 17.6498,9.21916 C17.9102,8.72958 17.9102,8.24 17.6498,7.75042 C17.3908,7.26084 16.9008,6.83622 16.1812,6.47656 C15.9222,6.34664 15.512,6.21182 14.952,6.07196 L14.5544,5.95926 C14.3724,5.90648 14.2156,5.85916 14.084,5.81716 C13.7242,5.69718 13.3644,5.54738 13.0046,5.36748 C12.6448,5.18772 12.3452,5.00782 12.1058,4.82806 C11.9658,4.71816 11.795,4.57326 11.5962,4.39336 C11.3162,4.11364 11.046,3.90882 10.787,3.7789 Z M2.4542,4.88798 L3.7128,4.25854 C4.5514,3.83896 5.5706,3.6291 6.7704,3.6291 C7.9688,3.6291 8.988,3.83896 9.8266,4.25854 C9.9876,4.33848 10.1864,4.48828 10.4272,4.70808 C10.8864,5.15776 11.4254,5.53744 12.0456,5.84712 C12.6644,6.1568 13.4246,6.42658 14.3234,6.65646 C14.763,6.7763 15.0626,6.87626 15.2222,6.95606 C16.0622,7.37578 16.4808,7.88524 16.4808,8.48472 C16.4808,9.0842 16.0622,9.5938 15.2222,10.01338 L13.9636,10.64282 C13.8236,10.71282 13.664,10.74768 13.4834,10.74768 C13.3042,10.74768 13.1446,10.71282 13.0046,10.64282 L2.4542,5.36748 C2.3142,5.29762 2.2442,5.21768 2.2442,5.1278 C2.2442,5.03778 2.3142,4.95784 2.4542,4.88798 Z M14.4424,4.64816 C15.1424,4.99788 15.9572,5.23518 16.8854,5.36006 C17.815,5.48494 18.7446,5.48494 19.6728,5.36006 C20.6024,5.23518 21.4172,4.99788 22.1158,4.64816 C22.8158,4.29844 23.2904,3.89132 23.5396,3.4268 C23.7902,2.96214 23.7902,2.49762 23.5396,2.03296 C23.2904,1.56844 22.8158,1.16132 22.1158,0.8116 C21.4172,0.46188 20.6024,0.22458 19.6728,0.0997 C18.7446,-0.02518 17.815,-0.02518 16.8854,0.0997 C15.9572,0.22458 15.1424,0.46188 14.4424,0.8116 C13.7438,1.16132 13.2692,1.56844 13.02,2.03296 C12.7694,2.49762 12.7694,2.96214 13.02,3.4268 C13.2692,3.89132 13.7438,4.29844 14.4424,4.64816 Z M21.1568,1.29124 C20.3574,0.89154 19.3984,0.69176 18.2798,0.69176 C17.1612,0.69176 16.2008,0.89154 15.4028,1.29124 C14.6034,1.6908 14.203,2.17044 14.203,2.72988 C14.203,3.28946 14.6034,3.76896 15.4028,4.16866 C16.2008,4.56822 17.1612,4.76814 18.2798,4.76814 C19.3984,4.76814 20.3574,4.56822 21.1568,4.16866 C21.9562,3.76896 22.3566,3.28946 22.3566,2.72988 C22.3566,2.17044 21.9562,1.6908 21.1568,1.29124 Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-44",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#476687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#273B50",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-45",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#294767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#273B50",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-46",
    points: "101.92 9.218 25.043 47.656 87.654 78.961 164.529 40.523"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-47",
    width: "110.6%",
    height: "121.3%",
    x: "-5.3%",
    y: "-7.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 0.42,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 1,
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.965517241  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-48",
    d: "M55.2062,7.9352 C55.9006,10.8766 56.5488,13.9104 57.1508,17.0366 C57.2894,17.801 56.8498,18.438 55.8306,18.9462 L37.9078,27.909 C36.981,28.3724 35.8694,28.6034 34.573,28.6034 C33.2766,28.6034 32.165,28.3724 31.2382,27.909 L2.338,13.4582 C1.4112,12.9948 0.9492,12.439 0.9492,11.7908 C0.9492,11.1426 1.4112,10.5868 2.338,10.1234 L20.2622,1.162 C21.28,0.6524 22.554,0.4326 24.0828,0.5026 L31.4636,0.8918 C35.1204,1.085 38.7268,1.2796 42.2842,1.4742 L43.6044,1.5092 C45.416,1.5918 46.8244,1.6926 47.831,1.8116 L48.1894,1.8564 C49.9954,2.065 51.3856,2.4122 52.3572,2.8994 C53.3302,3.3852 54.0246,4.0796 54.4418,4.9826 C54.6728,5.516 54.9052,6.2804 55.1362,7.2758 L55.1474,7.6146 C55.1586,7.7588 55.1782,7.8666 55.2062,7.9352 Z M33.4614,26.7974 C33.7862,26.9598 34.1558,27.0396 34.573,27.0396 C34.9902,27.0396 35.3598,26.9598 35.6846,26.7974 L53.6074,17.8346 C53.9322,17.6736 54.0708,17.465 54.0246,17.2102 C53.5612,14.7784 53.0348,12.2668 52.4426,9.674 L51.9414,7.4844 L51.8322,6.8824 C51.7384,6.4162 51.6348,6.0354 51.5228,5.74 L51.4542,5.5734 C51.177,4.8328 50.736,4.312 50.134,4.011 C49.6076,3.7464 48.7438,3.5462 47.544,3.4062 L47.0078,3.3502 C46.1748,3.2578 44.9008,3.1766 43.1872,3.1066 L41.937,3.038 C35.6846,2.6908 29.617,2.366 23.7356,2.065 C23.226,2.0426 22.8088,2.1112 22.4854,2.2736 L4.5612,11.235 C4.2364,11.3974 4.0754,11.5822 4.0754,11.7908 C4.0754,11.9994 4.2364,12.1842 4.5612,12.3466 L33.4614,26.7974 Z M47.8422,18.9812 C47.796,19.1436 47.656,19.271 47.425,19.3634 C47.194,19.4558 46.893,19.502 46.522,19.502 L32.2798,18.704 L30.8434,18.6326 C29.4966,18.5584 28.4242,18.4772 27.6262,18.3904 C25.7726,18.1594 24.3838,17.8122 23.457,17.3488 C22.5316,16.8854 21.8358,16.191 21.3738,15.2642 C21.0952,14.7084 20.8866,13.9328 20.748,12.9374 L19.1506,5.817 C19.1506,5.6308 19.243,5.481 19.4278,5.3648 C19.614,5.25 19.8688,5.18 20.1922,5.1562 L21.0266,5.0876 C21.3038,5.0876 21.5698,5.1394 21.8246,5.243 C22.0794,5.348 22.2306,5.481 22.2768,5.6434 L23.8042,12.7288 C23.9442,13.5856 24.129,14.2338 24.36,14.6748 C24.6386,15.4154 25.0782,15.9362 25.6802,16.2372 C26.2822,16.5382 27.3252,16.758 28.8064,16.898 C29.687,17.0128 30.9834,17.1052 32.697,17.1752 L46.8692,17.9396 C47.194,17.962 47.46,18.0376 47.6686,18.165 C47.8772,18.2924 47.9808,18.4254 47.9808,18.564 L47.8422,18.9812 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-50",
    cx: 25,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-51",
    width: "400%",
    height: "400%",
    x: "-150%",
    y: "-150%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-52",
    cx: 28.5,
    cy: 10.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-53",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 1   0 0 0 0 0.964555503   0 0 0 0 0.67496189  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-54",
    cx: 2,
    cy: 39,
    r: 2
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-55",
    width: "400%",
    height: "400%",
    x: "-150%",
    y: "-150%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 1   0 0 0 0 0.964555503   0 0 0 0 0.67496189  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-56",
    cx: 21.5,
    cy: 41.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-57",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-58",
    cx: 49,
    cy: 63,
    r: 2
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-59",
    width: "400%",
    height: "400%",
    x: "-150%",
    y: "-150%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-60",
    cx: 11,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-61",
    width: "700%",
    height: "700%",
    x: "-300%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-62",
    cx: 41,
    cy: 28,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-63",
    width: "700%",
    height: "700%",
    x: "-300%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 1   0 0 0 0 0.964555503   0 0 0 0 0.67496189  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-64",
    x1: "50%",
    x2: "50%",
    y1: "6.488%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00FFFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFF6"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-65",
    cx: 31.5,
    cy: 32.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-66",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-67",
    cx: 5.5,
    cy: 19.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-68",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-69",
    cx: 29.5,
    cy: 8.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-70",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-71",
    cx: 24.5,
    cy: 14.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-72",
    width: "500%",
    height: "500%",
    x: "-200%",
    y: "-200%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-73",
    cx: 1.5,
    cy: 30.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-74",
    width: "500%",
    height: "500%",
    x: "-200%",
    y: "-200%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-75",
    cx: 26.5,
    cy: 21.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-76",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 1   0 0 0 0 0.964555503   0 0 0 0 0.67496189  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-77",
    cx: 12.5,
    cy: 0.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-78",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-79",
    cx: 6.5,
    cy: 12.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-80",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 1   0 0 0 0 0.964555503   0 0 0 0 0.67496189  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-81",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "6.488%",
    stopColor: "#00FFFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFF6"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-82",
    cx: 20.5,
    cy: 20.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-83",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-84",
    cx: 3.5,
    cy: 12.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-85",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-86",
    cx: 18.5,
    cy: 5.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-87",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-88",
    cx: 16,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-89",
    width: "700%",
    height: "700%",
    x: "-300%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-90",
    cx: 1,
    cy: 20,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-91",
    width: "700%",
    height: "700%",
    x: "-300%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-92",
    cx: 16.5,
    cy: 13.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-93",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-94",
    cx: 7.5,
    cy: 0.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-95",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-96",
    cx: 4.5,
    cy: 7.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-97",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 1   0 0 0 0 0.964705882  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-98",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#476687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#273B50",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-99",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#294767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#273B50",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-100",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#476687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#273B50",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-101",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#294767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#273B50",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-102",
    x1: "34.648%",
    x2: "64.965%",
    y1: "13.715%",
    y2: "84.299%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF6AC",
    stopOpacity: 0.598
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95.74%",
    stopColor: "#FFF6AC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-103",
    width: "110.4%",
    height: "109.2%",
    x: "-5.2%",
    y: "-4.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-104",
    width: "110.4%",
    height: "109.2%",
    x: "-5.2%",
    y: "-4.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-105",
    x1: "34.648%",
    x2: "63.673%",
    y1: "13.715%",
    y2: "81.292%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF6AC",
    stopOpacity: 0.598
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF6AC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-106",
    width: "110.4%",
    height: "109.2%",
    x: "-5.2%",
    y: "-4.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-107",
    x1: "67.091%",
    x2: "32.298%",
    y1: "10.877%",
    y2: "89.495%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF6AC",
    stopOpacity: 0.598
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "96.315%",
    stopColor: "#FFF6AC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-108",
    width: "110.5%",
    height: "108.7%",
    x: "-5.2%",
    y: "-4.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-109",
    width: "110.5%",
    height: "108.7%",
    x: "-5.2%",
    y: "-4.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-110",
    width: "110.5%",
    height: "108.7%",
    x: "-5.2%",
    y: "-4.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-111",
    x1: "49.993%",
    x2: "50.006%",
    y1: "13.715%",
    y2: "81.292%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F6ACFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75.908%",
    stopColor: "#EDACFF",
    stopOpacity: 0.354
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E5ACFF"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-112",
    cx: 11.5,
    cy: 84.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-113",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.898039216   0 0 0 0 0.674509804   0 0 0 0 1  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-114",
    cx: 5.5,
    cy: 53.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-115",
    width: "500%",
    height: "500%",
    x: "-200%",
    y: "-200%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.898039216   0 0 0 0 0.674509804   0 0 0 0 1  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-116",
    cx: 8,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-117",
    width: "700%",
    height: "700%",
    x: "-300%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.898039216   0 0 0 0 0.674509804   0 0 0 0 1  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-118",
    cx: 17,
    cy: 44,
    r: 2
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-119",
    width: "400%",
    height: "400%",
    x: "-150%",
    y: "-150%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.898039216   0 0 0 0 0.674509804   0 0 0 0 1  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-120",
    cx: 2,
    cy: 148,
    r: 2
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-121",
    width: "400%",
    height: "400%",
    x: "-150%",
    y: "-150%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.898039216   0 0 0 0 0.674509804   0 0 0 0 1  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-122",
    cx: 14,
    cy: 135,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-123",
    width: "700%",
    height: "700%",
    x: "-300%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.898039216   0 0 0 0 0.674509804   0 0 0 0 1  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-124",
    cx: 10.5,
    cy: 124.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-125",
    width: "500%",
    height: "500%",
    x: "-200%",
    y: "-200%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.898039216   0 0 0 0 0.674509804   0 0 0 0 1  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-126",
    cx: 3,
    cy: 116,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-127",
    width: "700%",
    height: "700%",
    x: "-300%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.898039216   0 0 0 0 0.674509804   0 0 0 0 1  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-128",
    cx: 10,
    cy: 70,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-129",
    width: "700%",
    height: "700%",
    x: "-300%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.898039216   0 0 0 0 0.674509804   0 0 0 0 1  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-130",
    cx: 5.5,
    cy: 7.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-131",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.898039216   0 0 0 0 0.674509804   0 0 0 0 1  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-132",
    cx: 11.5,
    cy: 0.5,
    r: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-133",
    width: "1300%",
    height: "1300%",
    x: "-600%",
    y: "-600%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.898039216   0 0 0 0 0.674509804   0 0 0 0 1  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-134",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#476687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#273B50",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-135",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#294767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#273B50",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "continuum-signin",
    transform: "translate(-577 -259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(185 224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graphic",
    transform: "translate(392 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base",
    transform: "translate(185 232)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "url(#linearGradient-1)",
    points: "0 18.783 0 200.928 75.132 253 75.132 56.349"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2-Copy",
    fill: "url(#linearGradient-2)",
    points: "75.132 56.349 75.132 252.074 187.829 194.133 187.829 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "page",
    transform: "translate(.66 278.194)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#7A95B2",
    points: "75.132 93.915 0 56.349 0 62.61 75.132 100.176"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#476687",
    points: "75.132 93.915 75.132 100.176 187.829 43.827 187.829 37.566"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#90AECE",
    points: "112.698 0 0 56.349 75.132 93.915 187.829 37.566"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#476687",
    points: "62.16 31.08 55.899 34.211 118.734 65.628 124.995 62.497"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#476687",
    points: "49.638 37.341 43.377 40.471 93.915 65.74 100.176 62.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#476687",
    points: "37.116 43.602 30.855 46.733 71.776 67.193 78.038 64.063"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#476687",
    points: "24.594 49.863 18.333 52.993 81.168 84.411 87.429 81.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#C2D4E7",
    points: "112.698 0 62.16 25.269 137.292 62.835 187.829 37.566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-9",
    stroke: "#000",
    strokeDasharray: "3.78 3.78 0 0",
    strokeWidth: 1.26,
    d: "M112.6979,6.26108 L75.13198,25.04404 L137.74166,56.34888 L175.30786,37.56592 L112.6979,6.26108 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-10",
    stroke: "#476687",
    strokeDasharray: "3.78 3.78 0 0",
    strokeWidth: 1.26,
    d: "M112.6979,6.26108 L75.13198,25.04404 L137.74166,56.34888 L175.30786,37.56592 L112.6979,6.26108 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vertical",
    transform: "translate(67 88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-11",
    stroke: "#FFF",
    strokeDasharray: "3.78 3.78 0 0",
    strokeWidth: 1.26,
    d: "M40.09776,123.914399 L2.75402,142.568352 L2.53184,193.44794 L40.09776,174.66484 L40.09776,123.914399 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#C2D4E7",
    points: "37.812 .226 .024 18.668 2.629 19.971 39.965 1.302"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#7A95B2",
    points: "2.629 19.971 .024 18.668 .024 69.236 2.292 70.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#90AECE",
    points: "39.965 1.302 2.515 20.028 2.292 70.37 39.965 51.657"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#C2D4E7",
    points: "37.812 62.88 .024 81.323 2.629 82.625 39.965 63.957"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#7A95B2",
    points: "2.629 82.625 .024 81.323 .024 131.891 2.292 133.025"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#90AECE",
    points: "39.965 63.957 2.515 82.682 2.292 133.025 39.965 114.312"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(5.616 77.934)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#476687",
    points: "32.482 -1.404 .19 14.742 .19 41.418 32.482 25.272",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(4.212 20.37)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#476687",
    points: "34.132 -2.267 .436 14.581 .436 32.833 34.132 15.985",
    mask: "url(#mask-6)"
  }))), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-12",
    stroke: "#FFF",
    strokeWidth: 1.26,
    points: "21.315 183.933 21.315 202.839 27.315 205.716"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(7.2 143.853)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#FFF",
    points: "35.115 -16.464 -6.885 4.536 -6.885 46.537 35.115 25.537",
    mask: "url(#mask-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "user9",
    transform: "translate(321.013 262.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    fill: "#476687",
    d: "M7.77525,8.808835 C18.14225,3.625615 34.97445,3.625615 45.34145,8.808835 C55.70705,13.992195 55.70705,22.408575 45.34145,27.591935 C34.97445,32.775155 18.14225,32.775155 7.77525,27.591935 C-2.59175,22.408575 -2.59175,13.992195 7.77525,8.808835 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    fill: "#90AECE",
    d: "M7.77525,3.887415 C18.14225,-1.295805 34.97445,-1.295805 45.34145,3.887415 C55.70705,9.070775 55.70705,17.487155 45.34145,22.670375 C34.97445,27.853735 18.14225,27.853735 7.77525,22.670375 C-2.59175,17.487155 -2.59175,9.070775 7.77525,3.887415 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(5.187 5.846)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#FFF",
    points: "22.814 -9.164 54.565 6.712 19.928 24.03 -11.823 8.155",
    mask: "url(#mask-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "user8",
    transform: "translate(192.583 180.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    fill: "#476687",
    d: "M7.7742,8.80915 C18.1412,3.62635 34.9734,3.62635 45.3404,8.80915 C55.7074,13.99195 55.7074,22.40875 45.3404,27.59155 C34.9734,32.77575 18.1412,32.77575 7.7742,27.59155 C-2.5914,22.40875 -2.5914,13.99195 7.7742,8.80915 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    fill: "#90AECE",
    d: "M7.7742,3.88815 C18.1412,-1.29605 34.9734,-1.29605 45.3404,3.88815 C55.7074,9.07095 55.7074,17.48775 45.3404,22.67055 C34.9734,27.85335 18.1412,27.85335 7.7742,22.67055 C-2.5914,17.48775 -2.5914,9.07095 7.7742,3.88815 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(5.817 5.494)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#FFF",
    points: "22.184 -8.812 53.935 7.064 19.297 24.382 -12.453 8.506",
    mask: "url(#mask-12)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "user-beam",
    transform: "translate(192.583 54.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    fill: "url(#linearGradient-13)",
    fillOpacity: 0.2,
    d: "M0,136.338042 C1.87973333,147.047581 10.612,152.40235 26.1968,152.40235 C41.7816,152.40235 50.8382,147.047581 53.3666,136.338042 L53.3666,0.40235 L0,0.40235 L0,136.338042 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    stroke: "#07EEEB",
    strokeWidth: 2,
    d: "M7.7742,109.547 C18.1412,104.3628 34.9734,104.3628 45.3404,109.547 C55.7074,114.7298 55.7074,123.1466 45.3404,128.3294 C34.9734,133.5122 18.1412,133.5122 7.7742,128.3294 C-2.5914,123.1466 -2.5914,114.7298 7.7742,109.547 Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    stroke: "#07EEEB",
    d: "M7.7742,89.547 C18.1412,84.3628 34.9734,84.3628 45.3404,89.547 C55.7074,94.7298 55.7074,103.1466 45.3404,108.3294 C34.9734,113.5122 18.1412,113.5122 7.7742,108.3294 C-2.5914,103.1466 -2.5914,94.7298 7.7742,89.547 Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    stroke: "#07EEEB",
    d: "M7.7742,69.547 C18.1412,64.3628 34.9734,64.3628 45.3404,69.547 C55.7074,74.7298 55.7074,83.1466 45.3404,88.3294 C34.9734,93.5122 18.1412,93.5122 7.7742,88.3294 C-2.5914,83.1466 -2.5914,74.7298 7.7742,69.547 Z",
    opacity: 0.155
  }), /*#__PURE__*/React.createElement("g", {
    id: "particles1",
    transform: "translate(4.417 78.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-15)",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-17)",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF6AC",
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-19)",
    xlinkHref: "#path-18"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-21)",
    xlinkHref: "#path-20"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF6AC",
    xlinkHref: "#path-20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-23)",
    xlinkHref: "#path-22"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-25)",
    xlinkHref: "#path-24"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-27)",
    xlinkHref: "#path-26"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF6AC",
    xlinkHref: "#path-26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-29)",
    xlinkHref: "#path-28"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "user7",
    transform: "translate(256.021 159.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-26",
    fill: "#476687",
    d: "M5.70045,6.45855 C13.30245,2.65755 25.64485,2.65755 33.24545,6.45855 C40.84745,10.25955 40.84745,16.43075 33.24545,20.23175 C25.64485,24.03135 13.30245,24.03135 5.70045,20.23175 C-1.90015,16.43075 -1.90015,10.25955 5.70045,6.45855 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-27",
    fill: "#90AECE",
    d: "M5.70045,2.85075 C13.30245,-0.95025 25.64485,-0.95025 33.24545,2.85075 C40.84745,6.65035 40.84745,12.82155 33.24545,16.62255 C25.64485,20.42355 13.30245,20.42355 5.70045,16.62255 C-1.90015,12.82155 -1.90015,6.65035 5.70045,2.85075 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(4.379 4.017)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-31",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-30"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#FFF",
    points: "16.153 -6.45 39.434 5.19 14.036 17.889 -9.244 6.248",
    mask: "url(#mask-31)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "user6",
    transform: "translate(344.718 175.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-31",
    fill: "#476687",
    d: "M7.77525,8.80915 C18.14085,3.62635 34.97445,3.62635 45.34145,8.80915 C55.70705,13.99195 55.70705,22.40875 45.34145,27.59155 C34.97445,32.77575 18.14085,32.77575 7.77525,27.59155 C-2.59175,22.40875 -2.59175,13.99195 7.77525,8.80915 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-32",
    fill: "#90AECE",
    d: "M7.77525,3.88815 C18.14085,-1.29605 34.97445,-1.29605 45.34145,3.88815 C55.70705,9.07095 55.70705,17.48775 45.34145,22.67055 C34.97445,27.85335 18.14085,27.85335 7.77525,22.67055 C-2.59175,17.48775 -2.59175,9.07095 7.77525,3.88815 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(5.282 6.03)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-33",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-32"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#FFF",
    points: "22.719 -9.348 54.47 6.527 19.832 23.846 -11.918 7.97",
    mask: "url(#mask-33)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "user5",
    transform: "translate(390.852 205.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-36",
    fill: "#476687",
    d: "M4.92345,6.26465 C11.48945,2.57845 22.14905,2.57845 28.71365,6.26465 C35.27825,9.95085 35.27825,15.93585 28.71365,19.62065 C22.14905,23.30685 11.48945,23.30685 4.92345,19.62065 C-1.64115,15.93585 -1.64115,9.95085 4.92345,6.26465 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-37",
    fill: "#90AECE",
    d: "M4.92345,2.76465 C11.48945,-0.92155 22.14905,-0.92155 28.71365,2.76465 C35.27825,6.45085 35.27825,12.43585 28.71365,16.12205 C22.14905,19.80685 11.48945,19.80685 4.92345,16.12205 C-1.64115,12.43585 -1.64115,6.45085 4.92345,2.76465 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(3.548 4.439)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-35",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-34"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    fill: "#FFF",
    points: "14.184 -6.798 34.293 4.491 12.357 16.807 -7.751 5.517",
    mask: "url(#mask-35)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "user4",
    transform: "translate(384.564 244.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-41",
    fill: "#476687",
    d: "M3.81255,4.8503 C8.89595,1.9957 17.15035,1.9957 22.23375,4.8503 C27.31715,7.7042 27.31715,12.33848 22.23375,15.19252 C17.15035,18.04656 8.89595,18.04656 3.81255,15.19252 C-1.27085,12.33848 -1.27085,7.7042 3.81255,4.8503 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-42",
    fill: "#90AECE",
    d: "M3.81255,2.1399 C8.89595,-0.7133 17.15035,-0.7133 22.23375,2.1399 C27.31715,4.9945 27.31715,9.6285 22.23375,12.48254 C17.15035,15.33672 8.89595,15.33672 3.81255,12.48254 C-1.27085,9.6285 -1.27085,4.9945 3.81255,2.1399 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(2.836 3.188)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-37",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-36"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#FFF",
    points: "10.894 -5.016 26.464 3.725 9.479 13.262 -6.09 4.52",
    mask: "url(#mask-37)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "user3",
    transform: "translate(284.504 295.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-46",
    fill: "#476687",
    d: "M4.9602,6.31029 C11.5724,2.59721 22.3118,2.59721 28.924,6.31029 C35.5376,10.02337 35.5376,16.05233 28.924,19.76541 C22.3118,23.47849 11.5724,23.47849 4.9602,19.76541 C-1.6534,16.05233 -1.6534,10.02337 4.9602,6.31029 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-47",
    fill: "#90AECE",
    d: "M4.9602,2.78481 C11.5724,-0.92827 22.3118,-0.92827 28.924,2.78481 C35.5376,6.49789 35.5376,12.52685 28.924,16.23993 C22.3118,19.95301 11.5724,19.95301 4.9602,16.23993 C-1.6534,12.52685 -1.6534,6.49789 4.9602,2.78481 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-50",
    transform: "translate(3.896 4.337)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-39",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-38"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    fill: "#FFF",
    points: "13.966 -6.714 34.222 4.659 12.125 17.065 -8.13 5.692",
    mask: "url(#mask-39)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "user1",
    transform: "translate(158.228 268.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-51",
    fill: "#476687",
    d: "M7.7742,8.808975 C18.1412,3.625615 34.9748,3.625615 45.3404,8.808975 C55.7074,13.992195 55.7074,22.408575 45.3404,27.591935 C34.9748,32.775155 18.1412,32.775155 7.7742,27.591935 C-2.5914,22.408575 -2.5914,13.992195 7.7742,8.808975 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-52",
    fill: "#90AECE",
    d: "M7.7742,3.887415 C18.1412,-1.295805 34.9748,-1.295805 45.3404,3.887415 C55.7074,9.070775 55.7074,17.487155 45.3404,22.670515 C34.9748,27.853735 18.1412,27.853735 7.7742,22.670515 C-2.5914,17.487155 -2.5914,9.070775 7.7742,3.887415 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-55",
    transform: "translate(5.572 6.185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-41",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-40"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-53",
    fill: "#FFF",
    points: "22.429 -9.503 54.18 6.373 19.543 23.691 -12.208 7.816",
    mask: "url(#mask-41)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "user2",
    transform: "translate(216.593 298.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-56",
    fill: "#476687",
    d: "M5.16705,5.854345 C12.05645,2.409505 23.24385,2.409505 30.13325,5.854345 C37.02265,9.299045 37.02265,14.892465 30.13325,18.337305 C23.24385,21.782005 12.05645,21.782005 5.16705,18.337305 C-1.72235,14.892465 -1.72235,9.299045 5.16705,5.854345 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-57",
    fill: "#90AECE",
    d: "M5.16705,2.583525 C12.05645,-0.861175 23.24385,-0.861175 30.13325,2.583525 C37.02265,6.028365 37.02265,11.621785 30.13325,15.066485 C23.24385,18.511325 12.05645,18.511325 5.16705,15.066485 C-1.72235,11.621785 -1.72235,6.028365 5.16705,2.583525 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-60",
    transform: "translate(3.207 4.177)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-43",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-42"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-58",
    fill: "#FFF",
    points: "15.403 -6.382 36.504 4.169 13.483 15.678 -7.617 5.128",
    mask: "url(#mask-43)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "column",
    transform: "translate(405 333)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "url(#linearGradient-44)",
    points: ".398 .665 .398 79.894 23.93 94.909 23.931 12.365"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2-Copy",
    fill: "url(#linearGradient-45)",
    points: "23.931 12.365 23.93 93.703 47.462 77.66 47.813 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "envelope-group",
    transform: "translate(184.786 180.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "envelope-base",
    transform: "translate(0 7.57)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-61",
    fill: "#7A95B2",
    points: "75.131 93.914 0 56.349 0 62.609 75.131 100.175"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-62",
    fill: "#476687",
    points: "75.131 93.914 75.131 100.175 187.83 43.826 187.83 37.565"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-63",
    fill: "#90AECE",
    points: "112.697 0 0 56.349 75.131 93.914 187.83 37.565"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "envelope-shadow",
    fill: "#476687",
    points: "101.92 19.219 25.043 57.658 87.654 88.962 164.529 50.523"
  }), /*#__PURE__*/React.createElement("g", {
    id: "envelope-outline",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-47)",
    xlinkHref: "#path-46"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#00FFF6",
    strokeWidth: 0.84,
    xlinkHref: "#path-46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "envelope",
    transform: "translate(25.043)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-66",
    fill: "#8BFFFB",
    points: "76.877 0 0 38.438 62.611 69.742 139.486 31.304"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-69",
    transform: "translate(35.17 20.59)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-49",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-48"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-67",
    fill: "#318582",
    points: "87.927 11.791 34.573 -14.886 -18.781 11.791 34.573 38.468",
    mask: "url(#mask-49)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "particles3",
    transform: "translate(324 94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-51)",
    xlinkHref: "#path-50"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-53)",
    xlinkHref: "#path-52"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF6AC",
    xlinkHref: "#path-52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-55)",
    xlinkHref: "#path-54"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF6AC",
    xlinkHref: "#path-54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-57)",
    xlinkHref: "#path-56"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-59)",
    xlinkHref: "#path-58"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-61)",
    xlinkHref: "#path-60"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-63)",
    xlinkHref: "#path-62"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF6AC",
    xlinkHref: "#path-62"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "user-beam2",
    transform: "translate(256 63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    fill: "url(#linearGradient-64)",
    fillOpacity: 0.2,
    d: "M0,103.740396 C1.37369816,111.913465 7.7551877,116 19.1444686,116 C30.5337496,116 37.15226,111.913465 39,103.740396 L39,0 L0,0 L0,103.740396 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    stroke: "#07EEEB",
    strokeWidth: 2,
    d: "M5.56181841,84.7816787 C12.9785779,81.0727738 25.0206709,81.0727738 32.4374304,84.7816787 C39.8541899,88.4895821 39.8541899,94.5111691 32.4374304,98.2190725 C25.0206709,101.926976 12.9785779,101.926976 5.56181841,98.2190725 C-1.85393947,94.5111691 -1.85393947,88.4895821 5.56181841,84.7816787 Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    stroke: "#07EEEB",
    d: "M5.56181841,70.7816787 C12.9785779,67.0727738 25.0206709,67.0727738 32.4374304,70.7816787 C39.8541899,74.4895821 39.8541899,80.5111691 32.4374304,84.2190725 C25.0206709,87.9269758 12.9785779,87.9269758 5.56181841,84.2190725 C-1.85393947,80.5111691 -1.85393947,74.4895821 5.56181841,70.7816787 Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    stroke: "#07EEEB",
    d: "M5.56181841,55.7816787 C12.9785779,52.0727738 25.0206709,52.0727738 32.4374304,55.7816787 C39.8541899,59.4895821 39.8541899,65.5111691 32.4374304,69.2190725 C25.0206709,72.9269758 12.9785779,72.9269758 5.56181841,69.2190725 C-1.85393947,65.5111691 -1.85393947,59.4895821 5.56181841,55.7816787 Z",
    opacity: 0.155
  }), /*#__PURE__*/React.createElement("g", {
    id: "particles2",
    transform: "translate(3 62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-66)",
    xlinkHref: "#path-65"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-68)",
    xlinkHref: "#path-67"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-67"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-70)",
    xlinkHref: "#path-69"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-72)",
    xlinkHref: "#path-71"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-74)",
    xlinkHref: "#path-73"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-76)",
    xlinkHref: "#path-75"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF6AC",
    xlinkHref: "#path-75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-78)",
    xlinkHref: "#path-77"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-80)",
    xlinkHref: "#path-79"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF6AC",
    xlinkHref: "#path-79"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "user-beam3",
    transform: "translate(385 72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    fill: "url(#linearGradient-81)",
    fillOpacity: 0.2,
    d: "M0,167.236674 C0.880575741,180.412225 4.97127417,187 12.2720953,187 C19.5729164,187 23.8155513,180.412225 25,167.236674 L25,0 L0,0 L0,167.236674 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    stroke: "#07EEEB",
    strokeWidth: 2,
    d: "M3.51272742,166.75685 C8.19699655,164.414383 15.802529,164.414383 20.4867981,166.75685 C25.1710673,169.098683 25.1710673,172.901791 20.4867981,175.243625 C15.802529,177.585458 8.19699655,177.585458 3.51272742,175.243625 C-1.17090914,172.901791 -1.17090914,169.098683 3.51272742,166.75685 Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    stroke: "#07EEEB",
    d: "M3.51272742,157.75685 C8.19699655,155.414383 15.802529,155.414383 20.4867981,157.75685 C25.1710673,160.098683 25.1710673,163.901791 20.4867981,166.243625 C15.802529,168.585458 8.19699655,168.585458 3.51272742,166.243625 C-1.17090914,163.901791 -1.17090914,160.098683 3.51272742,157.75685 Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    stroke: "#07EEEB",
    d: "M3.51272742,147.75685 C8.19699655,145.414383 15.802529,145.414383 20.4867981,147.75685 C25.1710673,150.098683 25.1710673,153.901791 20.4867981,156.243625 C15.802529,158.585458 8.19699655,158.585458 3.51272742,156.243625 C-1.17090914,153.901791 -1.17090914,150.098683 3.51272742,147.75685 Z",
    opacity: 0.155
  }), /*#__PURE__*/React.createElement("g", {
    id: "particles4",
    transform: "translate(2 152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-83)",
    xlinkHref: "#path-82"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-85)",
    xlinkHref: "#path-84"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-87)",
    xlinkHref: "#path-86"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-86"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-89)",
    xlinkHref: "#path-88"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-91)",
    xlinkHref: "#path-90"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-93)",
    xlinkHref: "#path-92"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-95)",
    xlinkHref: "#path-94"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-94"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-97)",
    xlinkHref: "#path-96"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00FFF6",
    xlinkHref: "#path-96"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "column",
    transform: "translate(301 372)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "url(#linearGradient-98)",
    points: ".189 .775 0 97.445 37.754 126.201 37.754 19.453"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2-Copy",
    fill: "url(#linearGradient-99)",
    points: "37.754 19.453 38.132 142.807 76 84.866 75.881 .39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "column",
    transform: "translate(367 352)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "url(#linearGradient-100)",
    points: ".832 .382 .832 79.372 24.364 93.909 24.365 12.148"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2-Copy",
    fill: "url(#linearGradient-101)",
    points: "24.365 12.148 24.365 93.909 47.896 77.866 48.247 .206"
  })), /*#__PURE__*/React.createElement("g", {
    id: "servers",
    transform: "translate(276.189 .3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box",
    transform: "translate(129.21 298)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-79",
    fill: "#7A95B2",
    points: "0 11.766 0 35.298 23.533 47.064 23.533 23.532"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-80",
    fill: "#476687",
    points: "47.064 11.766 23.533 23.532 23.533 47.064 47.415 35.122"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-81",
    fill: "#90AECE",
    points: "23.533 0 0 11.766 23.533 23.532 47.064 11.766"
  })), /*#__PURE__*/React.createElement("g", {
    id: "windows",
    fill: "#90AECE",
    transform: "translate(131.946 315.64)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-82",
    points: "42.116 0 24.058 9.03 24.058 12.454 42.116 3.424"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-83",
    points: "18.059 9.455 0 .425 0 3.849 18.059 12.879"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-84",
    points: "42.116 5.269 24.058 14.299 24.058 17.723 42.116 8.693"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-85",
    points: "18.059 14.98 0 5.95 0 9.374 18.059 18.404"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-86",
    points: "42.116 10.757 24.058 19.786 24.058 23.21 42.116 14.181"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-87",
    points: "18.059 20.211 0 11.181 0 14.605 18.059 23.635"
  })), /*#__PURE__*/React.createElement("g", {
    id: "box",
    transform: "translate(91.643 316.783)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-88",
    fill: "#7A95B2",
    points: "0 11.766 0 35.298 23.533 47.064 23.533 23.532"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-89",
    fill: "#476687",
    points: "47.064 11.766 23.533 23.532 23.533 47.064 47.415 35.122"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-90",
    fill: "#90AECE",
    points: "23.533 0 0 11.766 23.533 23.532 47.064 11.766"
  }), /*#__PURE__*/React.createElement("g", {
    id: "windows",
    fill: "#90AECE",
    transform: "translate(2.737 17.64)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-91",
    points: "42.118 0 24.058 9.03 24.058 12.454 42.118 3.424"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-92",
    points: "18.059 9.455 0 .425 0 3.849 18.059 12.879"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-93",
    points: "42.118 5.269 24.058 14.299 24.058 17.723 42.118 8.693"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-94",
    points: "18.059 14.98 0 5.95 0 9.374 18.059 18.404"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-95",
    points: "42.118 10.757 24.058 19.786 24.058 23.21 42.118 14.181"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-96",
    points: "18.059 20.211 0 11.181 0 14.605 18.059 23.635"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "big-box",
    transform: "translate(25 316.02)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-70",
    fill: "#7A95B2",
    points: "0 18.783 0 56.349 37.565 75.132 37.565 37.566"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-71",
    fill: "#476687",
    points: "75.131 18.783 37.565 37.566 37.565 75.132 75.692 56.069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-72",
    fill: "#90AECE",
    points: "37.565 0 0 18.783 37.565 37.566 75.131 18.783"
  })), /*#__PURE__*/React.createElement("g", {
    id: "windows",
    fill: "#FFF6AC",
    transform: "translate(29.368 344.181)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-73",
    points: "67.235 0 38.405 14.415 38.405 19.881 67.235 5.466"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-74",
    points: "28.829 15.093 0 .678 0 6.144 28.829 20.559"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-75",
    points: "67.235 8.412 38.405 22.827 38.405 28.293 67.235 13.878"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-76",
    points: "28.829 23.913 0 9.498 0 14.964 28.829 29.379"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-77",
    points: "67.235 17.172 38.405 31.587 38.405 37.053 67.235 22.638"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-78",
    points: "28.829 32.265 0 17.85 0 23.316 28.829 37.731"
  })), /*#__PURE__*/React.createElement("g", {
    id: "light",
    transform: "translate(67.773 344.7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "url(#linearGradient-102)",
    points: "0 14.415 28.83 0 57.484 50.938 28.654 65.353",
    filter: "url(#filter-103)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4-Copy",
    fill: "url(#linearGradient-102)",
    points: "0 22.415 28.83 8 57.484 58.938 28.654 73.353",
    filter: "url(#filter-104)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4-Copy-2",
    fill: "url(#linearGradient-105)",
    points: "0 31.467 28.83 17.052 57.484 67.99 28.654 82.405",
    filter: "url(#filter-106)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "light",
    fill: "url(#linearGradient-107)",
    transform: "translate(.811 344.86)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    points: "57.386 14.415 28.557 0 0 54.84 28.693 69.259",
    filter: "url(#filter-108)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5-Copy",
    points: "57.386 23.255 28.557 8.84 0 63.679 28.693 78.099",
    filter: "url(#filter-109)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5-Copy-2",
    points: "57.386 32.255 28.557 17.84 0 72.679 28.693 87.099",
    filter: "url(#filter-110)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "triangle",
    fill: "#E88BFF",
    stroke: "#E88BFF",
    strokeWidth: 1.2,
    transform: "translate(120.811 273.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1",
    fillOpacity: 0.15,
    strokeOpacity: 0.2,
    d: "M32.8767,52.6584696 L32.6481215,1.71217489 L63.2844947,37.4545722 L32.8767,52.6584696 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-2",
    fillOpacity: 0.15,
    strokeOpacity: 0.2,
    d: "M1.03584727,37.3337032 L31.4480567,1.70042249 L31.6766684,52.6541138 L1.03584727,37.3337032 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3",
    fillOpacity: 0.05,
    strokeOpacity: 0.1,
    d: "M32.8769089,21.0573241 L32.6593357,1.72525808 L61.820669,35.7467774 L32.8769089,21.0573241 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-4",
    fillOpacity: 0.05,
    strokeOpacity: 0.1,
    d: "M2.46433609,35.8857406 L31.4589248,1.69549793 L31.6768801,21.0615133 L2.46433609,35.8857406 Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "url(#linearGradient-111)",
    points: "150.622 .699 155.622 .699 155.116 276.375 152.852 276.375 150.622 276.375"
  }), /*#__PURE__*/React.createElement("g", {
    id: "particles5",
    transform: "translate(144.811 118.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-113)",
    xlinkHref: "#path-112"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E5ACFF",
    xlinkHref: "#path-112"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-115)",
    xlinkHref: "#path-114"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E5ACFF",
    xlinkHref: "#path-114"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-117)",
    xlinkHref: "#path-116"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E5ACFF",
    xlinkHref: "#path-116"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-119)",
    xlinkHref: "#path-118"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E5ACFF",
    xlinkHref: "#path-118"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-121)",
    xlinkHref: "#path-120"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E5ACFF",
    xlinkHref: "#path-120"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-123)",
    xlinkHref: "#path-122"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E5ACFF",
    xlinkHref: "#path-122"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-125)",
    xlinkHref: "#path-124"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E5ACFF",
    xlinkHref: "#path-124"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-127)",
    xlinkHref: "#path-126"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E5ACFF",
    xlinkHref: "#path-126"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-129)",
    xlinkHref: "#path-128"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E5ACFF",
    xlinkHref: "#path-128"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-131)",
    xlinkHref: "#path-130"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E5ACFF",
    xlinkHref: "#path-130"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-133)",
    xlinkHref: "#path-132"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E5ACFF",
    xlinkHref: "#path-132"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "column",
    transform: "translate(.66 322.021)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "url(#linearGradient-134)",
    points: "0 18.783 0 127.735 75.132 179.807 75.132 56.349"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2-Copy",
    fill: "url(#linearGradient-135)",
    points: "75.132 56.349 75.132 179.807 187.829 121.866 187.829 0"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGraphic);
export default __webpack_public_path__ + "static/media/login-graphic.e3f029d8b26f47bd2f5ce6636ac9055a.svg";
export { ForwardRef as ReactComponent };